import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=1c23729f&scoped=true"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=1c23729f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23729f",
  null
  
)

export default component.exports